export default __webpack_public_path__ + "static/media/img_step_lucia01_m.a1d3387e.jpg";